import {
  RigFracActivityMetric,
  RigFracGroupBy,
  RigFracTimeScale
} from "constants/charts.enums";
import { createMergeWithDefaults } from "entities/utils";
import { RigFracActivityChartRequestType } from "types";

import { RIG_FRAC_PLASMA_PALETTE } from "./rigFracColorPalette";

// Lean request for the Rig/Frac Activity Over Time chart (EVA-76).
// No BASE_CHART_REQUEST: this chart carries none of the wells/facilities
// payload — see specs/EVA-76-activity-chart-widget/contracts/.
export const DEFAULT_RIG_FRAC_ACTIVITY_REQUEST: RigFracActivityChartRequestType = {
  chartType: "RigFracActivity",
  primaryMetric: RigFracActivityMetric.RigCount,
  secondaryMetric: RigFracActivityMetric.FracCrewCount,
  groupBy: RigFracGroupBy.Operator,
  timeScale: RigFracTimeScale.Quarterly,
  customRange: null,
  filters: {},
  bbox: null,
  // Default palette is Plasma; the controller assigns the effective palette
  // after createMergeWithDefaults (see useRigFracActivityController) so a
  // user's pick never array-index-merges against this default.
  colorPalette: RIG_FRAC_PLASMA_PALETTE
};

export const generateRigFracActivityRequestBody = createMergeWithDefaults(
  DEFAULT_RIG_FRAC_ACTIVITY_REQUEST
);
